import axios from 'axios';

export default {
  getData: async () => {
    return axios.get(`${process.env.REACT_APP_USER_SERVICE_URL}/api/v1/users/data`);
  },
  getMyOffices: async () => {
    return axios.get(`${process.env.REACT_APP_USER_SERVICE_URL}/api/v1/users/my-offices`);
  },
  recoverPassword: async (userEmail) => {
    return axios.post(`${process.env.REACT_APP_USER_SERVICE_URL}/api/v1/users/recover-password/${userEmail}`);
  },
  changePassword: async (data) => {
    return axios.post(`${process.env.REACT_APP_USER_SERVICE_URL}/api/v1/users/change-password`, data);
  },
  create: async (data) => {
    return axios.post(`${process.env.REACT_APP_USER_SERVICE_URL}/api/v1/users/self-create`, data);
  },
  validateActivateCode: async (code) => {
    return axios.post(`${process.env.REACT_APP_USER_SERVICE_URL}/api/v1/users/activate/${code}`);
  },
  resendActivateCode: async (code) => {
    return axios.post(`${process.env.REACT_APP_USER_SERVICE_URL}/api/v1/users/resend-activate-code/${code}`);
  },
  updateProfile: async (data) => {
    return axios.put(`${process.env.REACT_APP_USER_SERVICE_URL}/api/v1/users/update-profile`, data);
  },
}
